<div id="emoji-picker-container" style="width: 352px"></div>
